import { Button, Card, CardContent, Grid, MenuItem, Select, TextField, Typography } from '@mui/material';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { FaEdit, FaEraser } from 'react-icons/fa';
import Notification from '../../components/Notification/Notification';
import ConfirmDialog from '../../components/Notification/ConfirmDialog';
import MultiManual from '../../components/Manual/MultiManual';
import UserPermission from '../../components/UserPermission';
import api from '../../services/api';
import { Link } from 'react-router-dom';
import Table from '../../components/Table';

const classes = {
  textField: {
    width: '100%',
    backgroundColor: '#fff',
  },
  buttonSubmit: {
    marginTop: 20,
  },
  formControl: {
    marginLeft: 5,
    marginTop: 16,
    width: '50%'
  },
  textTitle: {
    margin: 8,
    color: '#103168',
    fontWeight: 600,
    marginBottom: 30,
  },
  buttonConfirm: {
    backgroundColor: '#1551B3',
    color: '#fff',
    borderRadius: 20,
    height: '45px',
    textTransform: 'capitalize',
    fontWeight: 'bold',
    fontSize: 15,
    marginTop: '17px',
    minWidth: '220px'
  },
  message: {
    padding: 10,
    backgroundColor: '#FFFBE8',
    color: 'rgba(0,0,0,0.8)',
    borderRadius: 7,
    width: '100%'
  },
  cardRoot: {
    borderRadius: '17px',
    backgroundColor: '#F5F5F5',
    boxShadow: 'none',
  },
  labelInput: {
    fontFamily: 'Rawline',
    color: '#333333',
    fontWeight: 'bold',
    paddingLeft: 2,
    fontSize: 14,
    marginBottom: '0.5rem'
  },
  buttonClear: {
    backgroundColor: '#F5F5F5',
    color: '#174FB3',
    borderRadius: 20,
    height: '45px',
    textTransform: 'capitalize',
    fontWeight: 'bold',
    fontSize: 15,
    marginTop: '17px',
    minWidth: '220px'
  },
};



export default function StatusRegister() {

  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [type, setType] = useState('');
  const [status, setStatus] = useState([]);
  const [refresh, setRefresh] = useState(true);

  let userPermission = UserPermission();

  const [notify, setNotify] = useState({ isOpen: false, message: '', type: '', title: '' });
  const [confirmDialog, setConfirmDialog] = useState({ isOpen: false, title: '', subTitle: '' });

  const handleDeleteStatus = useCallback(async (id) => {
    try {
      await api.delete(`/complaint-statuses/${id}`);
      setNotify({
        isOpen: true,
        message: 'Status deletado com sucesso.',
        type: 'error',
        title: 'Deletado',
      });

      setRefresh(true);

    } catch (err) {
      const statusCodeKnown = [422];
      const statusCode = err?.response?.status;
      let message = err?.response?.data?.error?.message;

      if (!statusCodeKnown.includes(statusCode)) {
        message = 'Erro desconhecido ao deletar Status, tente novamente.';
      }

      setNotify({
        isOpen: true,
        message,
        type: 'error',
        title: 'Erro',
      });

    } finally {
      setConfirmDialog({
        ...confirmDialog,
        isOpen: false,
      })
    }
  }, [confirmDialog]);

  const deleteStatusDialog = useCallback((dados) => {
    setConfirmDialog({
      isOpen: true,
      title: 'Você gostaria de deletar esse Status ?',
      subTitle: 'Esta ação não poderá ser desfeita',
      onConfirm: () => { handleDeleteStatus(dados) }
    })
  }, [handleDeleteStatus]);

  const columns = useMemo(
    () => [
      {
        Header: 'Nome',
        accessor: 'name',
      },
      {
        Header: 'Tipo',
        accessor: 'type',
      },
      {
        Header: 'Descrição',
        accessor: 'description',
        Cell: ({ row }) => (
          <span>{row.original.description || "Sem Descrição"}</span>
        )
      },
      {
        // Make an expander cell
        Header: () => null, // No header
        id: 'edit', // It needs an ID
        Cell: ({ row }) => (
          <Link to={`/status/${row.original.id}`}>
            <FaEdit
              size={20}
              color="#1351B4"
            />
          </Link>
        ),
      },
      {
        Header: () => null, // No header
        id: 'expander', // It needs an ID
        Cell: ({ row }) => (
          <Link to="#">
            <FaEraser
              size={20}
              color="#1351B4"
              onClick={() => {
                deleteStatusDialog(row.original.id)
              }}
            />
          </Link>)
      }
    ], [deleteStatusDialog]
  )


  async function handleCreateStatus(e) {
    e.preventDefault();

    const data = {
      name,
      description,
      type
    }

    if (!name || !description) {
      setNotify({
        isOpen: true,
        message: 'Preencha todos os campos obrigatórios.',
        type: 'error',
        title: 'Erro',
      });
      return;
    }

    try {
      await api.post('/complaint-statuses', data);
      setNotify({
        isOpen: true,
        message: 'Status cadastrado com sucesso.',
        type: 'success',
        title: 'Cadastrado',
      });
      clearForm();
      setRefresh(true);
    } catch {
      setNotify({
        isOpen: true,
        message: 'Erro ao cadastrar status, tente novamente.',
        type: 'error',
        title: 'Erro',
      });
    }
  }


  useEffect(() => {

    if (refresh === true) {
      if (userPermission === 'admin') {
        api.get(`/complaint-statuses`).then(response => {
          setStatus(response.data);
        });
        setRefresh(false);
      }
    }
  }, [userPermission, refresh]);

  const clearForm = () => {
    setName('');
    setDescription('');
    setType('');
  }

  return (
    <div className="cadastro-container">
      <form onSubmit={(e) => handleCreateStatus(e)} >
        <Card style={classes.cardRoot}>
          <CardContent>

            <Typography variant="h5" align="center" style={classes.textTitle}>
              Cadastro de tipos de Status
            </Typography>

            <div style={classes.message}>
              Preencha o formulário abaixo para cadastrar um tipo de status que está relacionado a uma ocorrência.
            </div>

            <Grid id="form-inputs" container spacing={2} alignItems="center" justifyContent="center" style={{ marginTop: 20 }}>
              <Grid item xs={12} md={6}>
                <Typography style={classes.labelInput}>
                  Nome do Status: *
                </Typography>

                <TextField
                  style={{ background: '#fff' }}
                  required
                  fullWidth
                  value={name}
                  onChange={e => setName(e.target.value)}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <Typography style={classes.labelInput}>
                  Etapa de status *
                </Typography>
                <Select
                  style={classes.textField}
                  fullWidth
                  onChange={e => setType(e.target.value)}
                  value={type}
                >
                  <MenuItem value={'Abertura'}>Abertura</MenuItem>
                  <MenuItem value={'Homologação'}>Homologação</MenuItem>
                  <MenuItem value={'Execução'}>Execução</MenuItem>
                  <MenuItem value={'Conclusão'}>Conclusão</MenuItem>
                </Select>
              </Grid>

              <Grid item xs={12} md={12}>
                <Typography style={classes.labelInput}>
                  Descrição do Status: *
                </Typography>

                <TextField
                  rows={4}
                  style={{ background: '#fff' }}
                  multiline
                  type='text'
                  fullWidth
                  value={description}
                  onChange={e => setDescription(e.target.value)}
                />
              </Grid>


            </Grid>

          </CardContent>
        </Card>

        <Grid container spacing={2} alignItems="center" justifyContent="center">
          <Grid item>
            <Button
              variant="outlined"
              startIcon={<FaEraser style={{ 'color': '#174FB3' }} />}
              type='button'
              onClick={() => clearForm()}
              style={classes.buttonClear}
            >
              Limpar
            </Button>
          </Grid>

          <Grid item>
            <Button
              id='register-button'
              variant="outlined"
              type='submit'
              starticon={<FaEdit style={{ 'color': '#fff' }} />}
              style={classes.buttonConfirm}
              onClick={(e) => handleCreateStatus(e)}
            >
              Cadastrar Status
            </Button>
          </Grid>
        </Grid>
      </form>

      <hr></hr>

      <Card id='types-list' style={classes.cardRoot}>
        <CardContent>
          <div className='tabela'>

            <Typography variant="h5" align="center" style={classes.textTitle}>
              Listagem de Tipos de Status
            </Typography>

            <div style={classes.message}>
              Abaixo será listado os status cadastrados no sistema.
              É possível editar ou excluir um status selecionando uma das opções a direita da tabela.
            </div>
          </div>
          <Table searchBy='name' label='Pesquise por um status cadastrado' columns={columns} data={status} />
        </CardContent>
      </Card>


      <Notification
        notify={notify}
        setNotify={setNotify}
      />
      <ConfirmDialog
        confirmDialog={confirmDialog}
        setConfirmDialog={setConfirmDialog}
      />

      <MultiManual
        components={[
          {
            id: 'form-inputs',
            message: 'Você pode preencher este formulário com os dados de um novo tipo',
            rect: { height: 20, top: -20 }
          },
          {
            id: 'register-button',
            message: 'Aperte o botão para confirmar o cadastro',
            rect: { height: 20, top: -20 }
          },
          {
            id: 'types-list',
            message: 'Aqui é a lista de tipos',
            rect: { height: 20, top: -20 }
          }

        ]}
      />
    </div>
  )
}
